export default "__VITE_ASSET__B6fDTVKL__"